import { useSearchStore } from '@base/stores/searchStore'
import { useAppIndexStore } from '@base/stores/indexStore'
import { ut_navigateNewRoute } from '@base/utils/utils'
import { ESpecialPage } from '@base/utils/constants'

export function useSearchInput() {
  const indexStore = useAppIndexStore()
  const searchStore = useSearchStore()

  const searchInput: Ref<string> = ref('')

  const suggestions: Ref<string[]> = ref([])
  async function getSearchSuggestions(value: string) {
    if (value.length > 2) {
      suggestions.value = await searchStore.callSuggestData(indexStore.state.paramData, value, 10)
    }
    else {
      suggestions.value = []
    }
  }

  function doSearch(value: string) {
    suggestions.value = []
    if (value.length > 0) {
      const path: string = useAppIndexStore().getRootPath + '/' + ESpecialPage.sp_search_result
      ut_navigateNewRoute(path, { term: value }, '', true)
    }
  }

  return {
    indexStore,
    searchInput: ref(searchInput),
    suggestions: ref(suggestions),
    getSearchSuggestions,
    doSearch,
  }
}
